<template>
    <div class="element-percentage"
        :class="[
            data.position ? 'float--' + data.position : 'float--center',
            data.collapsed ? 'is-' + data.collapsed : null,
            data.backgroundColor ? 'has-bg' : 'no-bg'
        ]"
        :style="{
            '--bg-color': data.backgroundColor,
            '--c-offset': sideOffset
        }" 
        ref="section"
    >
        <div class="split" 
            :class="[
                'split--' + data.imageAlignment,
                data.keepContentInContainer == 'container' ? 'within-container' : 'outside-container'
            ]"
        >
            <div class="split-primary">
                <div class="container">

                    <div class="container-inner" ref="container">
                        <div class="row">
                            <div 
                                v-if="data.imageAlignment=='left'" 
                                class="image-item-wrapper col-xs col-md-6"
                            >
                                <image-item
                                    :pinData="data.showPinterestButton ? {
                                        image: data.image,
                                        imageTitle: data.imageTitle
                                    } : null"
                                    class="image-item"
                                    v-if="data.image"
                                    :source="data.image"
                                    :alt="data.title"
                                    position="center"
                                    :allowFav="data.showFavButton"
                                    :imageID="data.imageID"
                                >
                                </image-item>
                            </div>

                            <div class="col-content col-xs col-md-5" 
                                :class="{ 
                                    'col-md-offset-1' : data.imageAlignment=='left' && data.keepContentInContainer=='container',
                                }"
                            >
                                <div class="split-content">
                                    <h2 v-if="data.showTitle" v-animate="'slide-up'" class="delay-1">{{data.title}}</h2>
                                    <div class="copy-content delay-2" v-html="data.content" v-animate="'slide-up'"></div>
                                    <a v-if="data.link"
                                        v-animate="'slide-up'" 
                                        class="button button--solid-black delay-3"
                                        :href="data.link"
                                        :aria-label="data.label"
                                        :title="data.label"
                                    >
                                        {{data.label}}
                                    </a>
                                </div>
                            </div>

                            <div 
                                v-if="data.imageAlignment=='right'" 
                                class="image-item-wrapper col-xs col-md-6"
                                :class="{ 
                                    'col-md-offset-1' : true,
                                }"
                            >
                                <image-item
                                    :pinData="data.showPinterestButton ? {
                                        image: data.image,
                                        imageTitle: data.imageTitle
                                    } : null"
                                    class="image-item"
                                    v-if="data.image"
                                    :source="data.image"
                                    :alt="data.title"
                                    position="center"
                                    :allowFav="data.showFavButton"
                                    :imageID="data.imageID"
                                >
                                </image-item>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import ImageItem from "../Image/ImageItem";
    import { debounce } from 'vue-debounce'

    export default {
        name: "element-Percentage",
        components: {
            ImageItem
        },
        props: {
            data: {
                type: Object
            }
        },
        data () {
            return {
                sideOffset: null
            }
        },
        created() {
            const app = this;
            app.resizeHandlerEvent = debounce(function(){
                app.resizeHandler();
            }, 250);
            window.addEventListener("resize", this.resizeHandlerEvent);

            // call this conditionally
            // possible value for this.data.collapsed : collapsed / null
            if(this.data.collapsed==='collapsed'){
                let emitClass = {
                    refIndex: this.data.refIndex,
                    offset: 0,
                    class: null
                };

                if (this.data.position==='top') {
                    emitClass.offset = -1;
                    emitClass.class = 'next-is-collapsed';
                    app.$emit('addNeighbourClass',emitClass);
                }

                if (this.data.position==='bottom') {
                    emitClass.offset = 1;
                    emitClass.class = 'prev-is-collapsed';
                    app.$emit('addNeighbourClass',emitClass);
                }

                if (this.data.position==='center') {
                    emitClass.offset = -1;
                    emitClass.class = 'next-is-collapsed-center';
                    app.$emit('addNeighbourClass',emitClass);

                    emitClass.offset = 1;
                    emitClass.class = 'prev-is-collapsed-center';
                    app.$emit('addNeighbourClass',emitClass);
                }
            }
        },
        destroyed() {
            window.removeEventListener("resize", this.resizeHandlerEvent);
        },
        mounted() {
            this.resizeHandler();
        },  
        computed: {

        },
        methods: {
            resizeHandlerEvent() {},
            resizeHandler () {
                const html = document.documentElement;
                this.sideOffset = ( (html.clientWidth - this.$refs.container.offsetWidth)/2 * (-1) ) + 'px';
            },
        }
    };
</script>

<style lang="scss" scoped>
    @import "../../../scss/abstracts/variables";

    .element-percentage {

        &::after {
            content: "";
            display: block;
            background-color: var(--bg-color);
            width: 100%;
            height: 100%;
            position: absolute;
            z-index: -1;
            top: 0;
        }
    }

    .split-primary {
        position: relative;
    }

    .container {
        .split-primary {
            .container {
                @media #{$below-md} {
                    width: 100%;
                    padding-left: 0;
                    padding-right: 0;
                }
            }
        }
    }

    .split {
        .container {
            .row {
                flex-grow: 1;
            }
            
            .col-image {
                @media #{$md} {
                    // min-height: var(--section-h, 600px);
                    // top: 50%;
                    // transform: translateY(-50%);
                }
            }
        }
    }
</style>